import { Box, Typography } from '@material-ui/core'
import { useStyles } from './styles'
const BasicApplicationDetails = (props) => {
  const { displayText } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Typography className={classes.sidetext}>Application Details</Typography>
      <Box className={classes.displayTextLayout}>
        <Typography className={classes.maintext}>{displayText}</Typography>
      </Box>
    </div>
  )
}
export default BasicApplicationDetails
